import * as types from "./mutation-type";

export default {
    [types.SET_CLIENT](state, payload) {
        state.client = payload;
    },
    [types.SET_CLIENT_LOGGED](state, payload) {
        state.clientLogged = payload
    },
    [types.SET_EMAIL_REGISTER](state, payload) {
        state.email_register = payload
    },
    [types.SET_LIST_EMPLOYEE_TYPES](state, payload) {
        state.list_employee_types = payload
    }
}
